/**
 * The three ways an asset can obtain its LMID: entering an existing one,
 * requesting a newly generated one on save, or deferring the LMID entirely
 * (which requires an internal order number instead).
 *
 * Shared by the add-asset LMID modal and the copy-asset dialog, whose dropdown
 * offers the same modes filtered by the copy matrix.
 */
export enum LmidModalMode {
    enterLmid = "enterLmid",
    requestLmid = "requestLmid",
    enterLmidLater = "enterLmidLater",
}
